// Hierarchical query keys for the documents domain (TanStack).
// Always invalidate via this factory, never a hand-typed string literal:
// typos won't lint-fail but will silently break invalidation.
export const documentsKeys = {
  all: ['documents'] as const,
  subtypes: (companyId: string) => [...documentsKeys.all, 'subtypes', companyId] as const,
  aggregations: () => [...documentsKeys.all, 'aggregations'] as const,
  documentsAggregations: (
    companyId: string,
    category: string,
    isConfidential: boolean,
    query: Record<string, unknown>,
    subtype: string | null,
  ) => [...documentsKeys.aggregations(), companyId, category, isConfidential, query, subtype] as const,
  tagSuggestions: (companyId: string, prefix: string) =>
    [...documentsKeys.all, 'tagSuggestions', companyId, prefix] as const,
  searchFavorites: (companyId: string) => [...documentsKeys.all, 'searchFavorites', companyId] as const,
  dashboardStats: (companyId: string) => [...documentsKeys.all, 'dashboardStats', companyId] as const,
  paymentEligibility: (companyId: string, documentId: string) =>
    [...documentsKeys.all, 'paymentEligibility', companyId, documentId] as const,
  ocrTextMap: (companyId: string, documentId: string) =>
    [...documentsKeys.all, 'ocrTextMap', companyId, documentId] as const,
  // Sorted ids: the same selection picked in a different order is the same
  // request, so it must land on the same cache entry.
  emailAutocomplete: (companyId: string, documentIds: readonly string[], linkID: string) =>
    [...documentsKeys.all, 'emailAutocomplete', companyId, [...documentIds].sort(), linkID] as const,
};
